import React from "react";

class TabsPrice extends React.Component {
   
    render(){
        return(
          <div className="TabsPriceMultiVendor">
              <div className="titles">
                  <span>سرویس</span>
                  <span>جزئیات</span>
                  </div>
                  {this.props.mechanicsInfgo.services.map((item)=>
                  
                  <div className="Names-Value">
                      <div className="names">{item.title}</div>
                      <span className="border"></span>
                      <div className="values">{item.garage_price}</div>
                      
                      </div>
                  )}
              </div>
        )
    }
}
export default TabsPrice
